/* eslint-disable import/prefer-default-export */
import React from 'react';
import { ErrorMessage, useField } from 'formik';

export const TextInput = ({ label, type, onChange, ...props }) => {
  const [field, meta] = useField(props.field);

  return (
    <>
      {label && (
        <label className="input-label" htmlFor={field.name}>
          {label}
        </label>
      )}
      <input
        id={field.name}
        type={type || 'text'}
        className={`input${meta.touched && meta.error ? ' input--error' : ''}${
          props.size ? ` input--${props.size}` : ''
        }`}
        {...props}
        {...field}
        onChange={onChange || field.onChange}
      />
      {props.append && <span className="input-append">{props.append}</span>}
      <ErrorMessage name={field.name}>
        {msg => <div className="input-error">{msg}</div>}
      </ErrorMessage>
    </>
  );
};
